import React from "react";
import { Radio } from "antd";

export const IncludeExamples = ({ selectedOption, onChange }) => (
    <Radio.Group
        onChange={(e) => onChange(e.target.value)}
        value={selectedOption}
    >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Radio value={false}>Exclude</Radio>
            <Radio value={true}>Include</Radio>
        </div>
    </Radio.Group>
);
